import { Switch, TextField } from '@ads/components-react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Textarea } from '@/shared/ui/atoms';
import { FormField } from '@/shared/ui/molecules';

import type { TabProps } from '../personFormSchema';

export function AdditionalInfoTab({ control, register }: TabProps) {
  const { t } = useTranslation('personManagement');

  return (
    <div className="flex flex-col gap-xxs">
      {/* Telefones */}
      <div className="grid grid-cols-1 gap-mini @2xl:grid-cols-3">
        <TextField
          fullWidth
          size="md"
          label={t('personForm.fields.celPhone')}
          placeholder="(00) 00000-0000"
          {...register('celPhone')}
        />
        <TextField
          fullWidth
          size="md"
          label={t('personForm.fields.homePhone')}
          placeholder="(00) 0000-0000"
          {...register('homePhone')}
        />
        <TextField
          fullWidth
          size="md"
          label={t('personForm.fields.workPhone')}
          placeholder="(00) 0000-0000"
          {...register('workPhone')}
        />
      </div>

      {/* Redes sociais e acadêmicas */}
      <div className="grid grid-cols-1 gap-mini @md:grid-cols-2">
        <TextField
          fullWidth
          size="md"
          type="url"
          label={t('personForm.fields.urlLinkedin')}
          placeholder="https://linkedin.com/in/..."
          {...register('urlLinkedin')}
        />
        <TextField
          fullWidth
          size="md"
          type="url"
          label={t('personForm.fields.urlLattes')}
          placeholder="http://lattes.cnpq.br/..."
          {...register('urlLattes')}
        />
      </div>

      {/* Mini currículo e observação */}
      <Controller
        name="miniCurriculum"
        control={control}
        render={({ field }) => (
          <FormField label={t('personForm.fields.miniCurriculum')}>
            <Textarea
              placeholder={t('personForm.fields.miniCurriculum')}
              value={(field.value as string) ?? ''}
              onChange={e => field.onChange(e.target.value)}
              rows={4}
            />
          </FormField>
        )}
      />
      <Controller
        name="observation"
        control={control}
        render={({ field }) => (
          <FormField label={t('personForm.fields.observation')}>
            <Textarea
              placeholder={t('personForm.fields.observation')}
              value={(field.value as string) ?? ''}
              onChange={e => field.onChange(e.target.value)}
              rows={4}
            />
          </FormField>
        )}
      />

      {/* Preferências de comunicação */}
      <div className="flex flex-col gap-quark">
        <h3 className="ts-heading-xs text-ctx-content-title">
          {t('personForm.fields.communicationPreferences')}
        </h3>
        <div className="flex flex-wrap gap-xs rounded-md border-hairline border-ctx-layout-border p-mini">
          <Controller
            name="receiveSms"
            control={control}
            render={({ field }) => (
              <Switch
                size="md"
                label={t('personForm.fields.receiveSms')}
                checked={field.value === true}
                onCheckedChange={field.onChange}
              />
            )}
          />
          <Controller
            name="receiveMarketing"
            control={control}
            render={({ field }) => (
              <Switch
                size="md"
                label={t('personForm.fields.receiveMarketing')}
                checked={field.value === true}
                onCheckedChange={field.onChange}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
}
